import { render, staticRenderFns } from "./WebsiteDepartmentModal.vue?vue&type=template&id=025588b8&"
import script from "./WebsiteDepartmentModal.vue?vue&type=script&lang=js&"
export * from "./WebsiteDepartmentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports